import store from '..';
import { Shifts } from '../../services';
import { createRestSlices, applyReducers } from './rest';

const {
    initialState,
    getReducer, listReducer, updateReducer, duplicateReducer,
    startCreateReducer, createReducer, deleteReducer,
    getAction, listAction, updateAction, duplicateAction,
    startCreateAction, createAction, deleteAction,
    linkedResourcesReducer, linkedResourcesAction
} = createRestSlices(Shifts);

initialState.suggestion                    = null;
initialState.isLoadingSuggestion           = false;
initialState.hasLoadingSuggestionError     = false;
initialState.loadingSuggestionErrorMessage = '';

const RESET_SUGGESTION           = 'kronos/shifts/RESET_SUGGESTION';
const LOADING_SUGGESTION_SUCCESS = 'kronos/shifts/LOADING_SUGGESTION_SUCCESS';
const LOADING_SUGGESTION_FAILURE = 'kronos/shifts/LOADING_SUGGESTION_FAILURE';

const suggestionReducer = (state, action) => {
    switch (action.type) {
        case RESET_SUGGESTION:
            return {
                ...state,
                suggestion: null,
                isLoadingSuggestion: true,
                hasLoadingSuggestionError: false,
                loadingSuggestionErrorMessage: null
            };
        case LOADING_SUGGESTION_SUCCESS:
            return {
                ...state,
                isLoadingSuggestion: false,
                hasLoadingSuggestionError: false,
                suggestion: action.suggestion,
                loadingSuggestionErrorMessage: null
            };
        case LOADING_SUGGESTION_FAILURE:
            return {
                ...state,
                isLoadingSuggestion: false,
                hasLoadingSuggestionError: true,
                loadingSuggestionErrorMessage: action.error.message
            };
        default:
            return state;
    }
};


/* Export reducer */
export default (state = initialState, action) => {
    return applyReducers(state, action, [
        getReducer, listReducer, updateReducer, duplicateReducer,
        startCreateReducer, createReducer, deleteReducer,
        linkedResourcesReducer, suggestionReducer
    ]);
}

export function resetSuggestion(data) {
    return dispatch => dispatch(resettingSuggestion());
}
function resettingSuggestion() { return { type: RESET_SUGGESTION } }
function loadingSuggestionSuccess(suggestion) { return { type: LOADING_SUGGESTION_SUCCESS, suggestion } }
function loadingSuggestionFailure(err) { return { type: LOADING_SUGGESTION_FAILURE, error: err } }
export function loadSuggestion(data) {
    return (dispatch) => {
        dispatch(resettingSuggestion());
        Shifts.loadSuggestion(data)
            .then(data => {
                const suggestion = data.suggestion;
                dispatch(loadingSuggestionSuccess(suggestion));
            })
            .catch(err => {
                console.log("err => ", err);
                dispatch(loadingSuggestionFailure(err))
            });
    }
}


/* Export CRUD actions */
export const resetShift               = startCreateAction;
export const startCreateShift         = startCreateAction;
export const createShift              = createAction;
export const loadShift                = getAction;
export const loadShifts               = listAction;
export const updateShift              = updateAction;
export const deleteShift              = deleteAction;
export const duplicateShift           = duplicateAction;
export const getShiftsLinkedResources = linkedResourcesAction;
